export default __webpack_public_path__ + "media/Productive.dcec6ff3.svg";